// ** react imports
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// ** enums imports
import { BUTTON_THEMES } from '../../../../enums/common';

const NormalButton = props => {
  // props
  const { theme, type, onClick, children, disabled, className = '' } = props;

  // hooks
  const buttonTheme = useMemo(() => {
    switch (theme) {
      case BUTTON_THEMES.PRIMARY:
        return 'bg-violet-600 hover:bg-violet-700 text-white dark:bg-violet-600 dark:hover:bg-violet-700 disabled:bg-violet-400 dark:disabled:bg-violet-400 focus:ring-violet-500';
      case BUTTON_THEMES.SECONDARY:
        return 'bg-white hover:bg-gray-50 border border-gray-200 text-gray-800 dark:bg-gray-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 dark:text-gray-200 disabled:bg-gray-100 dark:disabled:bg-gray-700 disabled:text-gray-400 dark:disabled:text-gray-500 focus:ring-gray-500';
      case BUTTON_THEMES.TERTIARY:
        return 'bg-transparent hover:bg-gray-100 border border-gray-200 text-violet-600 dark:bg-gray-800 dark:hover:bg-gray-700 dark:border-gray-700 dark:text-gray-200 disabled:text-gray-400 dark:disabled:text-gray-500 focus:ring-violet-500';
      case BUTTON_THEMES.DANGER:
        return 'bg-red-600 hover:bg-red-700 text-white dark:bg-red-600 dark:hover:bg-red-700 disabled:bg-red-400 dark:disabled:bg-red-400 focus:ring-red-500';
      case BUTTON_THEMES.WARNING:
        return 'bg-amber-500 hover:bg-amber-600 text-white dark:bg-amber-500 dark:hover:bg-amber-600 disabled:bg-amber-400 dark:disabled:bg-amber-400 focus:ring-amber-500';
      case BUTTON_THEMES.SUCCESS:
        return 'bg-emerald-600 hover:bg-emerald-700 text-white dark:bg-emerald-600 dark:hover:bg-emerald-700 disabled:bg-emerald-400 dark:disabled:bg-emerald-400 focus:ring-emerald-500';
      default:
        return 'bg-gray-200 hover:bg-gray-300 text-gray-800 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200 focus:ring-gray-500';
    }
  }, [theme]);

  return (
    <div className="">
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`btn ${buttonTheme} whitespace-nowrap transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 dark:focus:ring-offset-gray-800 ${className}`}
      >
        {children}
      </button>
    </div>
  );
};

NormalButton.propTypes = {
  theme: PropTypes.oneOf(Object.values(BUTTON_THEMES)),
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

NormalButton.defaultProps = {
  theme: BUTTON_THEMES.DEFAULT,
  type: 'button',
  onClick: () => {},
  disabled: false,
  className: '',
};

export default NormalButton;
